// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YKvT","top":"styles_top__2wkmO","left":"styles_left__1rXqp","description":"styles_description__2RUtv"};